import { generateQuery, generateURLWithParams } from 'utils';
import http from 'utils/http';

export const getCompanyActivities = (companyId, params = {}) => {
  const q = generateQuery([
    params.page > 1 ? `page=${params.page}` : '',
    params.page_size ? `page_size=${params.page_size}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/companies/${companyId}/activities/${q}`)
    .then((res) => res.data);
};

export const createCompanyNote = (companyId, data) => http
  .post(`v1/organizations/{{organizationId}}/companies/${companyId}/notes/`, data)
  .then((res) => res.data);

export const createCompanyCall = (companyId, data) => http
  .post(`v1/organizations/{{organizationId}}/companies/${companyId}/calls/`, data)
  .then((res) => res.data);

export const createCompanyEmail = (companyId, data) => http
  .post(`v1/organizations/{{organizationId}}/companies/${companyId}/emails/`, data)
  .then((res) => res.data);

export const createCompanyText = (companyId, data) => http
  .post(`v1/organizations/{{organizationId}}/companies/${companyId}/texts/`, data)
  .then((res) => res.data);

export const getIndustryChoices = () => http
  .get('v1/organizations/{{organizationId}}/companies/industry-choices/')
  .then((res) => res.data);

export const getCompanies = (query) => {
  const q = generateQuery([
    query?.search ? `search=${encodeURIComponent(query.search)}` : '',
    query?.page ? `page=${query.page}` : '',
    query?.page_size ? `page_size=${query.page_size}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/companies/${q}`)
    .then((res) => res.data);
};

export const fetchAllCompanies = (query) => {
  const params = { ...query };
  if (params.search) {
    params.search = encodeURIComponent(params.search);
  }
  const url = generateURLWithParams('v1/organizations/{{organizationId}}/companies/', params);
  return http.get(url);
};

export const getCompany = (companyId) => http
  .get(`v1/organizations/{{organizationId}}/companies/${companyId}`)
  .then((res) => res.data);

export const createCompany = (data) => http
  .post('v1/organizations/{{organizationId}}/companies/', data)
  .then((res) => res.data);

export const updateCompany = (companyId, data) => http
  .patch(`v1/organizations/{{organizationId}}/companies/${companyId}/`, data)
  .then((res) => res.data);

export const deleteCompany = (companyId) => http
  .delete(`v1/organizations/{{organizationId}}/companies/${companyId}/`)
  .then((res) => res.data);
